/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Aegis AO Soft LLC and Alexander Orlov.
 *
 * This code may be used, reproduced, modified, or distributed ONLY with the
 * prior written permission of Aegis AO Soft LLC / Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft LLC
 */


/*
 * Shared types for CreateUserAndAgreement page components
 */

export interface DriverFormData {
  firstName: string;
  lastName: string;
  middleName: string;
  companyName: string;
  email: string;
  phoneNumber: string;
  dateOfBirth: string;
  driverLicenseNumber: string;
  driverLicenseState: string;
  driverLicenseExpirationDate: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  FrontSideImage: File | null;
  BackSideImage: File | null;
  // Raw OCR/barcode payloads from the Scan License step.
  // Submitted to backend so it can skip re-running Document AI / PDF417 parsing.
  frontOcrRaw: unknown | null;
  backBarcodeRaw: unknown | null;
}

export const initialFormData: DriverFormData = {
  firstName: '',
  lastName: '',
  middleName: '',
  companyName: '',
  email: '',
  phoneNumber: '',
  dateOfBirth: '',
  driverLicenseNumber: '',
  driverLicenseState: '',
  driverLicenseExpirationDate: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zipCode: '',
  FrontSideImage: null,
  BackSideImage: null,
  frontOcrRaw: null,
  backBarcodeRaw: null,
};

export type PageStatus = 'loading' | 'ready' | 'submitting' | 'success' | 'error';
